import { useTranslation } from 'react-i18next';
import { CardHeader } from '@/components/base/Card';
import { caseloadStudents } from '@/mocks/dashboard';

export default function CaseloadGrid() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 rounded-xl border border-background-200 p-5">
      <CardHeader
        title={t('dashboard.myCaseload')}
        subtitle={t('dashboard.activeStudents', { count: caseloadStudents.length })}
        icon="ri-group-line"
        iconBg="bg-accent-100"
        action={
          <button className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-label font-medium text-foreground-500 bg-background-100 rounded-lg hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap">
            {t('common.viewAll')}
            <i className="ri-arrow-right-line" />
          </button>
        }
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {caseloadStudents.map((s) => (
          <div
            key={s.id}
            className="group p-4 rounded-lg bg-background-100 hover:bg-background-200 transition-all duration-200 cursor-pointer hover:-translate-y-0.5"
          >
            {/* Avatar + Name */}
            <div className="flex items-center gap-2.5 mb-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs font-700 font-label flex-shrink-0">
                {s.avatar}
              </div>
              <div className="min-w-0">
                <p className="text-sm font-label font-medium text-foreground-800 truncate">{s.name}</p>
                <p className="text-xs text-foreground-400 font-label">{s.age} yrs</p>
              </div>
            </div>

            {/* Domain tag */}
            <span className="inline-block px-2 py-0.5 rounded-full text-[10px] font-label font-medium bg-secondary-100 text-secondary-700 mb-3">
              {s.domain}
            </span>

            {/* Goal progress bar */}
            <div className="mb-2">
              <div className="flex items-center justify-between text-[10px] font-label mb-1">
                <span className="text-foreground-500">{t('dashboard.goalProgress')}</span>
                <span className="font-700 text-foreground-700">{s.goalProgress}%</span>
              </div>
              <div className="w-full h-1.5 rounded-full bg-background-300 overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all duration-500 ${
                    s.goalProgress >= 70 ? 'bg-semantic-success' :
                    s.goalProgress >= 40 ? 'bg-primary-500' :
                    'bg-semantic-warning'
                  }`}
                  style={{ width: `${s.goalProgress}%` }}
                />
              </div>
            </div>

            {/* Next session */}
            <div className="flex items-center gap-1.5 text-[10px] text-foreground-500 font-label">
              <i className="ri-calendar-line" />
              <span>{s.nextSession}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}